import React from 'react'
import { Typography } from '@mui/material'
import sxs from './_sxs'
import { FormSectionProps } from './_props'
import FlexBox from '../../flexBox/FlexBox'

const FormSection: React.FC<FormSectionProps> = ({ children, label, labelSideComponent }) => (
    <FlexBox sx={sxs.formSection} flexDirection="column" gap="1.5rem">
        <FlexBox alignItems="center" justifyContent="space-between" width="100%">
            {label && <Typography sx={sxs.formSectionLabel}>{label}</Typography>}
            {labelSideComponent}
        </FlexBox>
        <FlexBox
            justifyContent="space-between"
            flexDirection="row"
            flexWrap="wrap"
            gap="1rem"
            sx={sxs.formSectionInner}
        >
            {children}
        </FlexBox>
    </FlexBox>
)

export default FormSection
